// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/si-ha-documentation-schema',
  type: 'object',
  required: ['id', 'creatorId', 'userId'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    shareId: {
      type: 'string',
      format: 'uuid',
    },
    userId: {
      type: 'integer',
    },
    siHaDocumentationStatus: {
      enum: [
        1,
        2,
        3,
        4,
        5,
      ],
    },
    constructionPlanDocumentExternalId: {
      type: 'string',
      nullable: true,
    },
    locationMapDocumentExternalId: {
      type: 'string',
      nullable: true,
    },
    title: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    remark: {
      type: 'string',
      nullable: true,
    },
    projectNumber: {
      type: 'string',
      nullable: true,
      maxLength: 30,
    },
    clientCompanyName: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    clientAddressLine: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    clientPostalCode: {
      type: 'string',
      nullable: true,
      maxLength: 10,
    },
    clientCity: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    clientFirstName: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    clientLastName: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    clientEMail: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    clientPhoneNumber: {
      type: 'string',
      nullable: true,
      maxLength: 50,
    },
    addressLine: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    city: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    postalCode: {
      type: 'string',
      nullable: true,
      maxLength: 10,
    },
    nextInspectionDueDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    safetyHookIds: {
      type: 'array',
      nullable: true,
      items: {
        type: 'integer',
      },
    },
  },
} as IJSONSchema;

export default schema;
